<template>
    <div class="toasts-container">
        <TransitionGroup name="fade">
            <div
                v-for="toast in getToasts"
                :key="toast.message"
                :class="`toast -${toast.type}`"
            >
                {{ toast.message }}
            </div>
        </TransitionGroup>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters("toasts", ["getToasts"]),
    },
};
</script>

<style lang="scss">
@use "index";
</style>
